import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { setupI18n } from './i18n.ts';
import { setupTheme } from './theme-mode.ts';
import './styles.css';

/*
 * Il tema **prima** del primo disegno: applicarlo dopo vorrebbe dire un lampo
 * di chiaro sullo schermo di chi ha scelto lo scuro, di notte.
 */
setupTheme();

await setupI18n();

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
